import { Sponsor, SponsorItem } from 'types/domain';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface UseSponsorStoreProps {
    showSponsorItemsModal: boolean;
    showAcceptTerms: boolean;
    activeSponsor: Sponsor | null;
    activeItem: SponsorItem | null;
    setShowSponsorsItemsModal: (value: boolean) => void;
    setShowAcceptTerms: (value: boolean) => void;
    setActiveSponsor: (value: Sponsor) => void;
    setActiveItem: (value: SponsorItem | null) => void;
}

const useSponsorsStore = create<UseSponsorStoreProps>(set => ({
    showAcceptTerms: false,
    showSponsorItemsModal: false,
    activeSponsor: null,
    activeItem: null,
    setShowSponsorsItemsModal: showSponsorItemsModal => set({ showSponsorItemsModal }),
    setShowAcceptTerms: showAcceptTerms => set({ showAcceptTerms }),
    setActiveSponsor: (activeSponsor: Sponsor) => set({ activeSponsor }),
    setActiveItem: (activeItem: SponsorItem | null) => set({ activeItem }),
}));

export { useSponsorsStore };
